// extracted by mini-css-extract-plugin
export default {"cross":"Cross_cross__wpvZl"};